// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"6a1403e2","453":"d1dcb0fd","498":"e4eaaa54","508":"0c9150c4","616":"a866d611","690":"919ecb8c","796":"e906340a","815":"a5b03d4c"}[chunkId] + ".chunk.js";
};